import React, { useEffect, useState } from "react";
import image from "../../../Images/Screenshot 2024-12-08 230626.png";
import { useDispatch, useSelector } from "react-redux";
import { getAllMaintenanceScheduleById } from "../../../redux/MaintenanceScheduleSlice/MaintenanceScheduleSlice";
import { useNavigate, useParams } from "react-router-dom";
import MaintenanceItemInputs from "../../Inputs/MaintenanceItemInputs/MaintenanceItemInputs";
import { addImageForMaintenanceItem, updateMaintenanceItem } from "../../../redux/MaintenanceItemSlice/MaintenanceItemSlice";
import notify from "../../../hooks/useNotifaction";

export default function MaintenanceSchedule() {
  const dispatch = useDispatch();
  const { specificMaintenanceSchedule } = useSelector((state) => state.maintenanceSchedule);
  const { ScheduleId } = useParams();
  const [items, setItems] = useState([]);
  const [items2, setItems2] = useState([]);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getAllMaintenanceScheduleById(ScheduleId));
  }, [ScheduleId, dispatch]);

  useEffect(() => {
    if (specificMaintenanceSchedule?.scheduleItems?.length) {
      const newItems = specificMaintenanceSchedule.scheduleItems.map((item) => ({
        status: item.status,
        id: item.id,
        notes: item.notes,
        image: item.image,
        quantity:item?.quantity
      }));
      setItems(newItems);
    }
  }, [specificMaintenanceSchedule]);

  const handleInputChange = (e, id) => {
    let { name, value } = e.target;
    setItems((prevItems) => prevItems.map((item) => (item.id === id ? { ...item, [name]: value } : item)));
  };

  const haveItemsChanged = (originalItems, currentItems) => {
    if (originalItems.length !== currentItems.length) return true;
    return originalItems.some((original, index) => {
      const current = currentItems[index];
      return original.status !== current.status || original.notes !== current.notes || original.image !== current.image;
    });
  };
  useEffect(()=>{
    console.log("xxx",specificMaintenanceSchedule)
},[specificMaintenanceSchedule])


  const handleUpdate = async (e) => {
    e.preventDefault();

    // const originalItems = specificMaintenanceSchedule?.scheduleItems?.map((item) => ({
    //   status: item.status,
    //   id: item.id,
    //   notes: item.notes,
    //   image: item.image,
    //   quantity:item?.quantity
    // }));

    // const itemsChanged = haveItemsChanged(originalItems, items);

    // if (!itemsChanged && !file) {
    //   notify("لم يتم إجراء أي تغييرات على العناصر.", "warning");
    //   return;
    // }

    try {
      setLoading(true);
      if (file) {
        const formData = new FormData();
        formData.append("image", file.file);
        await dispatch(addImageForMaintenanceItem({ data: formData, id: file.id })).unwrap();
      }
      let res = await dispatch(updateMaintenanceItem({ items })).unwrap();
      notify(res?.message, "success");
      navigate(`/MaintenanceSchedules/${ScheduleId}/statusMaintenanceItem`);
      setLoading(false);
    } catch (error) {
      notify(error?.message || "حدث خطأ ");
      console.error("Update failed:", error);
    }
  };

  return (
    <>
      <div className="main">
        <div className="container-fluid">
          <div className="title">
            <h1 className="bg-100-text">جدول صيانة {specificMaintenanceSchedule?.contractSchedule?.branch?.company?.name}</h1>
            {/* <div className="d-flex">
              <p className="me-3 bg-100-text">فرع مكة</p>
              <p className="me-3 bg-200-text">الزيرة رقم : 2</p>
              <p className="bg-200-text">بتاريخ : 2021/10/10</p>
            </div> */}
          </div>

          <div className="card mt-5">
            {specificMaintenanceSchedule && Array.isArray(specificMaintenanceSchedule.scheduleItems) && specificMaintenanceSchedule.scheduleItems.length === 0 ? (
              <div className="p-5 text-center">
                <h3 className="text-muted">لا يوجد عناصر صيانة في هذا الجدول.</h3>
              </div>
            ) : specificMaintenanceSchedule?.scheduleItems?.length ? (
              <div id="carouselExampleIndicators" className="carousel slide">
                <div className="carousel-indicators">
                  {specificMaintenanceSchedule.scheduleItems.map((maintenanceSchedule, index) => (
                    <button key={index} type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to={index} className={index === 0 ? "active position-relative" : "position-relative"} aria-current={index === 0 ? "true" : "false"} aria-label={`Slide ${index}`}>
                      <div className="rounded-5 bg-100 position-absolute top-50 start-0 translate-middle d-flex justify-content-center align-items-center">
                        <i className="fa-solid fa-flag-checkered"></i>
                      </div>
                    </button>
                  ))}
                </div>

                <div className="carousel-inner">
                  <form onSubmit={handleUpdate}>
                    {specificMaintenanceSchedule.scheduleItems.map((maintenanceSchedule, index) => (
                      <div key={index} className={`carousel-item ${index === 0 ? "active" : ""}`}>
                        <h2 className="text-white mb-4">إضافة عنصر صيانة</h2>
                        <div className="mb-3 pt-5 pb-2 px-3 companyProfile">
                          <MaintenanceItemInputs items={items} standardItem={maintenanceSchedule} file={file} setFile={setFile} handleInputChange={handleInputChange} setItems={setItems} maintenanceItem={items[index]} isParentElement={true} />
                          {(index === specificMaintenanceSchedule.scheduleItems.length - 1 || file) && (
                            <div className="d-flex justify-content-end mt-5">
                              <button type="submit" className="btn btn-primary">
                                تحديث
                              </button>
                            </div>
                          )}
                        </div>
                        <div className="d-flex justify-content-between mx-5">
                          <div className="d-flex justify-content-between mx-5">
                            {index !== 0 && (
                              <button className="btn" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                                <span>السابق</span>
                              </button>
                            )}

                            {index !== specificMaintenanceSchedule.scheduleItems.length - 1 && (
                              <button className="btn" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                                <span>التالي</span>
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </form>
                </div>
              </div>
            ) : (
              <div className="p-5 text-center">
                <h3 className="text-muted">جاري تحميل عناصر الصيانة...</h3>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
